/**
 * Trust Badges – Motion animate/inView for hero features
 * Minimal: optional fade-in when block enters viewport
 */
import { inView } from 'motion';

const SELECTOR = '.wp-block-acf-trust-badges';

function init() {
  const blocks = document.querySelectorAll(SELECTOR);
  if (!blocks.length) return;

  blocks.forEach((block) => {
    inView(block, () => {
      block.classList.add('is-visible');
      return () => {};
    }, { margin: '-50px 0px -50px 0px', amount: 0.2 });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
